import { render, staticRenderFns } from "./HotelView.vue?vue&type=template&id=b385906e&scoped=true&"
import script from "./HotelView.vue?vue&type=script&lang=js&"
export * from "./HotelView.vue?vue&type=script&lang=js&"
import style0 from "./HotelView.vue?vue&type=style&index=0&id=b385906e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b385906e",
  null
  
)

export default component.exports